import styled from 'styled-components';
import { Flex } from '../../../components/blocks';
import { AppTheme } from '../../../styles/theme';
import { margin, MarginProps } from '../../../components/styles';

type Props = MarginProps & {
  gap?: keyof AppTheme['spaces'];
};

export const Section = styled(Flex)<Props>`
  flex-direction: column;
  gap: ${({ theme, gap }) => (gap ? theme.spaces[gap] : theme.spaces.xxxxl)};
  align-items: flex-start;
  max-width: ${({ theme }) => theme.windowSizes.m};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spaces.l};
  ${margin}
`;
